import Img from "../image";
import {useTranslation} from "next-i18next";
import {useRouter} from "next/router";
import Page from "../../lib/page";
import React from "react";

/**
 *
 * @param images
 * @returns {JSX.Element}
 * @constructor
 */
export default function ImageSlider({ images }) {
    // init
    const router = useRouter();
    const { t } = useTranslation();

    // create the page for having the language
    const page = new Page();
    page.init(router.locale);

    // render
    return (
        <>
            <div id="productImages" className="carousel carousel-dark slide" data-bs-interval="false">
                <div className="carousel-inner">
                    {images.map((image, index) =>
                        <div key={index} className={"carousel-item " + (0 === index ? "active" : "")}>
                            <div style={{maxHeight: 256 + 'px'}} className="text-center mw-50">
                                <Img
                                    url={image.url}
                                    alt={image.type}
                                    priority={index === 0}
                                    width={image.width}
                                    height={image.height}
                                    figure={true}
                                />
                            </div>
                        </div>
                    )}
                </div>
                <button className="carousel-control-prev" type="button" data-bs-target="#productImages"
                        data-bs-slide="prev">
                    <span className="carousel-control-prev-icon" aria-hidden="true" />
                    <span className="visually-hidden">{t('previous.page')}</span>
                </button>
                <button className="carousel-control-next" type="button" data-bs-target="#productImages"
                        data-bs-slide="next">
                    <span className="carousel-control-next-icon" aria-hidden="true" />
                    <span className="visually-hidden">{t('next.page')}</span>
                </button>
            </div>
        </>
    );
}